import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-tiktok-black">
      {/* Header */}
      <div className="bg-tiktok-surface border-b border-white/10">
        <div className="container mx-auto px-4 md:px-6 py-6">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-gray-400 hover:text-tiktok-cyan transition-colors"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 md:px-6 py-12 md:py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="max-w-3xl mx-auto"
        >
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-white mb-8">
            Datenschutzerklärung
          </h1>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-300">

            <section>
              <h2 className="text-xl font-bold text-white mb-4">1. Verantwortlicher</h2>
              <p>
                Verantwortlich für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="mt-4">
                <strong className="text-white">Erdem Trading GmbH</strong><br />
                Melchiorstraße 14<br />
                68167 Mannheim<br />
                Deutschland
              </p>
              <p className="mt-4">
                Geschäftsführer: Abdulaziz Erdem<br />
                E-Mail: info@pkwankauf24-7.de<br />
                Telefon: +49 179 8067007
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">2. Hosting</h2>
              <p>
                Diese Website wird bei <strong className="text-white">Vercel Inc.</strong> gehostet.
              </p>
              <p className="mt-4">
                Beim Aufruf dieser Website werden technisch erforderliche Informationen verarbeitet. Dazu können insbesondere folgende Daten gehören:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>IP-Adresse des anfragenden Geräts</li>
                <li>Datum und Uhrzeit des Zugriffs</li>
                <li>aufgerufene Ressourcen, zum Beispiel URL oder Dateiname</li>
                <li>übertragene Datenmenge</li>
                <li>Browsertyp und Browserversion</li>
                <li>verwendetes Betriebssystem</li>
                <li>Referrer-URL</li>
                <li>HTTP-Statusinformationen</li>
              </ul>
              <p className="mt-4">
                Die Verarbeitung erfolgt zur sicheren, stabilen und effizienten Bereitstellung dieser Website.
              </p>
              <p className="mt-4">
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der sicheren und technisch fehlerfreien Bereitstellung unserer Website.
              </p>
              <p className="mt-4">
                Die Speicherdauer richtet sich nach den technischen und vertraglichen Vorgaben des Hosting-Anbieters. Die Daten werden gelöscht, sobald der Zweck der Verarbeitung entfällt, soweit keine gesetzlichen Aufbewahrungspflichten bestehen.
              </p>
              <p className="mt-4">
                Empfänger der Daten ist:
              </p>
              <p className="mt-2">
                <strong className="text-white">Vercel Inc.</strong><br />
                340 S Lemon Ave #4133<br />
                Walnut, CA 91789<br />
                USA
              </p>
              <p className="mt-4">
                Es kann eine Datenübertragung in die USA stattfinden. Vercel ist nach eigenen Angaben unter dem EU-US Data Privacy Framework zertifiziert.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">3. Lokale Speicherung / Consent-Einstellungen</h2>
              <p>
                Diese Website nutzt die Local-Storage-Funktion Ihres Browsers, um Ihre Datenschutz- und Cookie-Einstellungen zu speichern. Es handelt sich hierbei nicht um ein klassisches Cookie, sondern um einen browserseitigen Speicher.
              </p>
              <p className="mt-4">
                Gespeichert werden insbesondere Informationen darüber, ob Sie in bestimmte Dienste eingewilligt oder diese abgelehnt haben.
              </p>
              <div className="mt-4 overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-white/10">
                      <th className="text-left py-2 text-white">Name</th>
                      <th className="text-left py-2 text-white">Zweck</th>
                      <th className="text-left py-2 text-white">Speicherart</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b border-white/5 align-top">
                      <td className="py-2 pr-3">cookieConsent</td>
                      <td className="py-2 pr-3">
                        Speichert Ihre Auswahl zu Datenschutz- und Cookie-Einstellungen,
                        insbesondere ob Marketing-Dienste erlaubt oder abgelehnt wurden
                      </td>
                      <td className="py-2">Local Storage</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="mt-4">
                Diese Speicherung ist technisch erforderlich, um Ihre Auswahl bei späteren Besuchen zu berücksichtigen und Ihnen die Website entsprechend Ihrer Datenschutz-Einstellungen bereitzustellen.
              </p>
              <p className="mt-4">
                Rechtsgrundlage ist § 25 Abs. 2 Nr. 2 TDDDG sowie Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der nutzerfreundlichen und datenschutzkonformen Verwaltung Ihrer Einwilligungen.
              </p>
              <p className="mt-4">
                Sie können die gespeicherten Einstellungen jederzeit über den Link „Cookie-Einstellungen" im Footer dieser Website ändern oder widerrufen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">4. Fahrzeugbewertungs-Formular</h2>
              <p>
                Auf unserer Website können Sie ein Formular zur Fahrzeugbewertung ausfüllen. Die von Ihnen eingegebenen Daten werden auf der Website erfasst und anschließend über einen WhatsApp-Link an uns übermittelt.
              </p>
              <p className="mt-4">Der Ablauf ist wie folgt:</p>
              <ol className="list-decimal list-inside mt-2 space-y-1">
                <li>Sie geben Ihre Daten in das Formular auf unserer Website ein.</li>
                <li>Die Daten werden lokal in Ihrem Browser zu einer Nachricht zusammengestellt.</li>
                <li>Durch Klick auf den Senden-Button öffnet sich WhatsApp mit der vorformulierten Nachricht.</li>
                <li>Erst wenn Sie die Nachricht in WhatsApp aktiv absenden, werden die Daten über WhatsApp an uns übermittelt.</li>
              </ol>
              <p className="mt-4">
                Dabei können insbesondere folgende Daten verarbeitet werden:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Fahrzeugdaten, zum Beispiel Marke, Modell, Baujahr, Kilometerstand, Kraftstoffart, Getriebe und Leistung</li>
                <li>Zustandsinformationen, zum Beispiel Fahrzeugzustand, TÜV-Status, Unfallschaden und gegebenenfalls Wunschpreis</li>
                <li>Kontaktdaten, zum Beispiel Name, Telefonnummer und E-Mail-Adresse</li>
                <li>optionale Nachricht</li>
              </ul>
              <p className="mt-4">
                Zweck der Verarbeitung ist die Bearbeitung Ihrer Anfrage und die Erstellung eines möglichen Ankaufsangebots für Ihr Fahrzeug.
              </p>
              <p className="mt-4">
                Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO, da die Verarbeitung zur Durchführung vorvertraglicher Maßnahmen auf Ihre Anfrage hin erfolgt.
              </p>
              <p className="mt-4">
                Die Daten werden für die Dauer der Anfragebearbeitung gespeichert. Soweit sich aus der Anfrage ein Vertragsverhältnis ergibt oder gesetzliche Aufbewahrungspflichten bestehen, erfolgt die Speicherung nach Maßgabe der gesetzlichen Fristen, insbesondere handels- und steuerrechtlicher Aufbewahrungspflichten. Danach werden die Daten gelöscht.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">5. Kontaktaufnahme über WhatsApp</h2>
              <p>
                Wenn Sie uns über WhatsApp kontaktieren, sei es über das Fahrzeugbewertungs-Formular oder direkt, werden Ihre Nachrichten und die darin enthaltenen Daten über WhatsApp verarbeitet.
              </p>
              <p className="mt-4">
                Anbieter für Nutzer innerhalb der Europäischen Region ist:
              </p>
              <p className="mt-2">
                <strong className="text-white">WhatsApp Ireland Limited</strong><br />
                4 Grand Canal Square<br />
                Grand Canal Harbour<br />
                Dublin 2<br />
                Irland
              </p>
              <p className="mt-4">
                Je nach Verarbeitungsvorgang kann auch eine Datenübertragung an Unternehmen der Meta-Gruppe, insbesondere an WhatsApp LLC in den USA, stattfinden. WhatsApp LLC ist nach eigenen Angaben unter dem EU-US Data Privacy Framework zertifiziert.
              </p>
              <p className="mt-4">
                Wenn Sie WhatsApp nutzen, gelten zusätzlich die Datenschutzbestimmungen von WhatsApp. Auf die Datenverarbeitung durch WhatsApp selbst haben wir nur begrenzten Einfluss. WhatsApp verarbeitet Daten insbesondere zur Bereitstellung des Messenger-Dienstes, zur Sicherheit und gegebenenfalls zu eigenen Zwecken gemäß den WhatsApp-Datenschutzhinweisen.
              </p>
              <p className="mt-4">
                Rechtsgrundlage für die Verarbeitung durch uns ist Art. 6 Abs. 1 lit. b DSGVO, soweit Ihre Kontaktaufnahme der Vertragsanbahnung oder der Durchführung vorvertraglicher Maßnahmen dient. In anderen Fällen erfolgt die Verarbeitung auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Unser berechtigtes Interesse liegt in der einfachen und schnellen Kommunikation mit Interessenten und Kunden.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">6. Google Ads Conversion-Tracking</h2>
              <p>
                Diese Website nutzt nach Ihrer Einwilligung das Conversion-Tracking von Google Ads. Anbieter ist:
              </p>
              <p className="mt-2">
                <strong className="text-white">Google Ireland Limited</strong><br />
                Gordon House<br />
                Barrow Street<br />
                Dublin 4<br />
                Irland
              </p>
              <p className="mt-4">
                Mit dem Google Ads Conversion-Tracking können wir nachvollziehen, ob Nutzer nach einem Klick auf eine Google-Anzeige eine bestimmte Aktion auf unserer Website ausführen, insbesondere das Absenden einer Anfrage über das Fahrzeugbewertungs-Formular. Dies hilft uns, die Wirksamkeit unserer Werbeanzeigen zu messen und unsere Werbung wirtschaftlich auszuwerten.
              </p>
              <p className="mt-4">
                Die Einbindung erfolgt nur, wenn Sie über unser Cookie- beziehungsweise Consent-Banner ausdrücklich in die Nutzung von Marketing-Diensten eingewilligt haben. Ohne Ihre Einwilligung wird das Google Ads Conversion-Tracking nicht für Marketingzwecke aktiviert.
              </p>
              <p className="mt-4">
                Wir setzen hierfür den Google Consent Mode v2 ein. Dabei werden die Consent-Signale für <code className="text-tiktok-cyan">ad_storage</code>, <code className="text-tiktok-cyan">analytics_storage</code>, <code className="text-tiktok-cyan">ad_user_data</code> und <code className="text-tiktok-cyan">ad_personalization</code> zunächst auf „denied" gesetzt. Erst nach Ihrer Einwilligung werden diese Werte auf „granted" gesetzt. Google beschreibt Consent Mode als Verfahren, mit dem der Einwilligungsstatus an Google übermittelt wird und Google-Tags ihr Verhalten entsprechend anpassen.
              </p>
              <p className="mt-4">
                Beim erfolgreichen Absenden des Fahrzeugbewertungs-Formulars kann nach erteilter Einwilligung ein Conversion-Ereignis an Google übermittelt werden.
              </p>
              <p className="mt-4"><strong className="text-white">Verwendete Conversion-ID:</strong></p>
              <p className="mt-1"><code className="text-tiktok-cyan">AW-18108998224</code></p>
              <p className="mt-4"><strong className="text-white">Verwendetes Conversion-Ereignis:</strong></p>
              <p className="mt-1"><code className="text-tiktok-cyan">ads_conversion_Submit_lead_form_1</code></p>
              <p className="mt-4">
                Dabei können insbesondere folgende Informationen verarbeitet werden:
              </p>
              <ul className="list-disc list-inside mt-2 space-y-1">
                <li>Information, dass eine Conversion stattgefunden hat</li>
                <li>Zeitpunkt der Conversion</li>
                <li>aufgerufene Website beziehungsweise URL</li>
                <li>technische Informationen zum Browser und Endgerät</li>
                <li>gegebenenfalls Informationen zum vorherigen Anzeigenklick</li>
                <li>IP-Adresse und weitere technische Verbindungsdaten</li>
              </ul>
              <p className="mt-4">
                Eine direkte persönliche Identifikation durch uns erfolgt hierbei nicht. Wir erhalten von Google keine Informationen, mit denen wir einzelne Websitebesucher unmittelbar identifizieren können.
              </p>
              <p className="mt-4">
                Rechtsgrundlage für die Speicherung von Informationen auf Ihrem Endgerät und den Zugriff hierauf ist § 25 Abs. 1 TDDDG. Rechtsgrundlage für die anschließende Verarbeitung personenbezogener Daten ist Ihre Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO.
              </p>
              <p className="mt-4">
                Empfänger der Daten ist Google Ireland Limited. Eine Übermittlung an Google LLC in den USA kann nicht ausgeschlossen werden. Google LLC ist nach eigenen Angaben unter dem EU-US Data Privacy Framework zertifiziert.
              </p>
              <p className="mt-4">
                Sie können Ihre Einwilligung jederzeit mit Wirkung für die Zukunft über den Link „Cookie-Einstellungen" im Footer dieser Website widerrufen. Nach dem Widerruf wird das Google Ads Conversion-Tracking nicht weiter aktiviert.
              </p>
              <p className="mt-4">
                Weitere Informationen zur Datenverarbeitung durch Google finden Sie unter:{' '}
                <a
                  href="https://policies.google.com/privacy"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-tiktok-cyan hover:underline"
                >
                  https://policies.google.com/privacy
                </a>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">7. Keine weiteren Tracking- oder Analyse-Dienste</h2>
              <p>
                Über das oben beschriebene Google Ads Conversion-Tracking hinaus verwendet diese Website keine weiteren Analyse- oder Marketing-Dienste wie Google Analytics, Facebook Pixel, Matomo oder vergleichbare Tools.
              </p>
              <p className="mt-4">
                Insbesondere findet keine dauerhafte Analyse des allgemeinen Nutzerverhaltens auf unserer Website durch uns statt. Das Google Ads Conversion-Tracking dient ausschließlich der Messung von Anfragen, die im Zusammenhang mit unseren Werbeanzeigen stehen.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">8. Ihre Rechte</h2>
              <p>Sie haben bezüglich Ihrer personenbezogenen Daten folgende Rechte:</p>
              <div className="mt-4 space-y-4">
                <div>
                  <p><strong className="text-white">Auskunftsrecht gemäß Art. 15 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können Auskunft darüber verlangen, ob und welche personenbezogenen Daten wir über Sie verarbeiten.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Berichtigungsrecht gemäß Art. 16 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können die Berichtigung unrichtiger oder die Vervollständigung unvollständiger personenbezogener Daten verlangen.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Löschungsrecht gemäß Art. 17 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können die Löschung Ihrer personenbezogenen Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten oder andere rechtliche Gründe entgegenstehen.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Recht auf Einschränkung der Verarbeitung gemäß Art. 18 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können unter bestimmten Voraussetzungen die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten verlangen.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Recht auf Datenübertragbarkeit gemäß Art. 20 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können verlangen, Ihre personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Widerspruchsrecht gemäß Art. 21 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können der Verarbeitung Ihrer personenbezogenen Daten widersprechen, soweit diese auf Art. 6 Abs. 1 lit. f DSGVO beruht.
                  </p>
                </div>
                <div>
                  <p><strong className="text-white">Widerruf einer Einwilligung gemäß Art. 7 Abs. 3 DSGVO</strong></p>
                  <p className="mt-1">
                    Sie können eine einmal erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.
                  </p>
                </div>
              </div>
              <p className="mt-6">
                Zur Ausübung Ihrer Rechte können Sie uns jederzeit kontaktieren:
              </p>
              <p className="mt-2">
                E-Mail: <strong className="text-tiktok-cyan">info@pkwankauf24-7.de</strong>
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">9. Beschwerderecht bei der Aufsichtsbehörde</h2>
              <p>
                Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
              </p>
              <p className="mt-4">Zuständige Aufsichtsbehörde für unser Unternehmen ist:</p>
              <p className="mt-2">
                <strong className="text-white">Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Baden-Württemberg</strong><br />
                Lautenschlagerstraße 20<br />
                70173 Stuttgart<br />
                Deutschland
              </p>
              <p className="mt-4">
                Telefon: 0711 615541-0<br />
                E-Mail: poststelle@lfdi.bwl.de
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-white mb-4">10. Aktualität dieser Datenschutzerklärung</h2>
              <p>
                Diese Datenschutzerklärung ist aktuell gültig.
              </p>
              <p className="mt-4">
                Stand: Mai 2026
              </p>
              <p className="mt-4">
                Durch die Weiterentwicklung unserer Website, technische Änderungen oder geänderte gesetzliche beziehungsweise behördliche Vorgaben kann es notwendig werden, diese Datenschutzerklärung anzupassen. Die jeweils aktuelle Fassung finden Sie auf dieser Website.
              </p>
            </section>

          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Datenschutz;
